import React from 'react';
import { User } from '@supabase/supabase-js';
import { UserRecord } from '../model/types';

export interface MyContext {
  userRecord: UserRecord | null;
  user: User | null;
  isEmailVerified: boolean;
  isLoading: boolean;
  authError: string | null;
  getNotifications: () => any[] | undefined;
  getFollows: () => any[] | undefined;
  checkEmailVerification: () => Promise<boolean>;
  clearAuthError: () => void;
}

export const AuthContext = React.createContext<MyContext>({
  user: null,
  userRecord: null,
  isEmailVerified: false,
  isLoading: true,
  authError: null,
  getNotifications: () => [],
  getFollows: () => [],
  checkEmailVerification: async () => false,
  clearAuthError: () => {},
});
